import { Component, Input } from "@angular/core";
import { FormControl } from "@angular/forms";

@Component({
  selector: "app-input",
  templateUrl: "./input.component.html",
  styleUrls: ["./input.component.scss"],
})
export class InputComponent {
  @Input() control: FormControl;
  @Input() label: string = "";
  @Input() type: string = "";
  @Input() radius: string = "16px";
  @Input() textarea: boolean = false;
  @Input() disabled: boolean = false;
  @Input() value: string = "";

  constructor() {}

  openDateSelector() {
    const dateInput: any = document.querySelector('input[type="date"]');
    dateInput.showPicker();
  }
}
